const config = {
    IDLE_TIMEOUT: 15*60 * 1000,
    AUTO_LOGOUT_TIME: 60 * 1000, 
  };
  
  export default config;
  